export const ORDERS_POLL_INTERVAL_MS = 15 * 1000;

export const orderIds = (orders) =>
  (Array.isArray(orders) ? orders : [])
    .map((order) => (order == null ? null : order.id))
    .filter((id) => id !== null && id !== undefined)
    .map(String);

export const newOrderIds = (seenIds, orders) => {
  const seen = seenIds instanceof Set ? seenIds : new Set(seenIds || []);
  return orderIds(orders).filter((id) => !seen.has(id));
};

export const alertText = (count) =>
  count === 1 ? "1 new delivery order is waiting" : `${count} new delivery orders are waiting`;
